module.exports = __webpack_public_path__ + "static/line-oa-b1fbe61a4a81a00a33823f7c4845cfbd.svg";